export default "__VITE_ASSET__BEgHBUU2__"